import React, { useMemo } from "react";
import { useOutletContext } from "react-router-dom";
import { useAnalyses } from "@/context/AnalysisContext";
import { HistoryCard } from "@/components/HistoryCard";
import { EmptyState } from "@/components/EmptyState";
import { Film, SearchX } from "lucide-react";

export default function AdLibrary() {
  const { analyses } = useAnalyses();
  const { search } = useOutletContext();

  const filtered = useMemo(() => {
    const q = (search || "").trim().toLowerCase();
    if (!q) return analyses;
    return analyses.filter((a) => {
      const m = a.metadata || {};
      return (
        (m.title || "").toLowerCase().includes(q) ||
        (m.channel || "").toLowerCase().includes(q) ||
        (a.video_id || "").toLowerCase().includes(q)
      );
    });
  }, [analyses, search]);

  return (
    <div className="space-y-6">
      <div>
        <p className="overline text-muted-foreground">Your teardowns</p>
        <h1 className="font-display text-2xl sm:text-3xl font-bold tracking-tight mt-1">Video Library</h1>
      </div>

      {analyses.length === 0 ? (
        <EmptyState
          icon={Film}
          title="No analyses yet"
          description="Your analyzed YouTube videos will appear here."
        />
      ) : filtered.length === 0 ? (
        <EmptyState
          icon={SearchX}
          title="No results found"
          description={`Nothing matches "${search}". Try a different title, channel or video ID.`}
          showAction={false}
        />
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4" data-testid="library-grid">
          {filtered.map((a) => (
            <HistoryCard key={a.id} analysis={a} />
          ))}
        </div>
      )}
    </div>
  );
}
